module.exports = __webpack_public_path__ + "img/Menu-19.62e4968a.webp";